import { init as initFullStory, FullStory } from '@fullstory/browser';
import { isInAppBrowser } from '~/utils/device.utils';

export function loadFullStory() {
    if (!isInAppBrowser()) {
        initFullStory({ orgId: 'JY2NT' });
        FullStory('shutdown'); // we want to wait before starting to record until we determine if the user should be sampled, see useInitScreenRecording
    }
}

type FSActionType = (typeof FSActionTypeArray)[number];
const FSActionTypeArray = [
    'click',
    'loaded',
    'load',
    'success',
    'error',
    'action',
    'cancel'
] as const;

export type FSSessionType = 'client_experience' | 'public_file';

// this is the way FS forces to write the properties (ending with "_str" for string)
// https://help.fullstory.com/hc/en-us/articles/360020623274-FS-event-API-Sending-custom-event-data-into-FullStory
interface ParsedString {
    name: FSActionType;
    description: string;
}

export const parseEventNameForFS = (
    input: string,
    action: FSActionType = null
): ParsedString => {
    if (action !== null) {
        return { name: action, description: input };
    }
    const colonIndex = input.indexOf(':');

    if (colonIndex !== -1) {
        const name = input.slice(0, colonIndex).trim() as FSActionType;

        if (FSActionTypeArray.includes(name)) {
            const description = input.slice(colonIndex + 1).trim();
            return { name, description };
        }
    }

    // Default to "action" type if not a valid ActionType or no colon is found
    return { name: 'action', description: input.trim() };
};
